import { defineMessages } from 'utils/intl';

export default defineMessages({
  title: 'Dlaczego miałbyś nam zaufać?',
  suitcaseHeader: 'Doświadczenie praktyczne',
  suitcaseDescription: 'realizujemy kompleksowe procesy wymiany i modernizacji sprzętu',
  expertHeader: 'Wiedza ekspercka',
  expertDescription: 'doradzamy, jak zoptymalizować zarządzanie hardware IT w Twojej organizacji',
  scaleHeader: 'Skala działalności',
  scaleDescription: 'jednorazowo dostarczamy nawet kilka tysięcy urządzeń gotowych do pracy',
  originalHeader: 'Tylko oryginalne podzespoły',
  originalDescription:
    'wszystkie modyfikacje sprzętu wynikające ze specyfikacji odbywają się w fabryce producenta i podlegają fabrycznej gwarancji',
  coffeeHeader: 'Łatwość i wsparcie',
  coffeDescription:
    'na każdym etapie realizacji zamówienia dzielimy się wiedzą i doświadczeniem, pomagamy w przygotowaniu niezbędnej dokumentacji, udostępniamy sprzętu demo oraz świadczymy usługi wdrożeniowe i obsługę powdrożeniową',
  shieldHeader: 'Legalność i bezpieczeństwo',
  shieldDescription:
    'jesteśmy oficjalnym partnerem handlowym czołowych producentów IT, sprzedajemy sprzęt podlegający obsłudze serwisowej i gwarancyjnej producenta',
  stonksHeader: 'Wspieramy B2B',
  stonksDescription:
    'obsługujemy wyłącznie firmy i instytucje publiczne, starając zapewnić najwyższą jakość obsługi klienta',
  likeHeader: 'Referencje',
  likeDescription:
    'sprawnie zrealizowaliśmy dostawy m.in. dla gmin, powiatów, miast, politechnik, uniwersytetów, akademii, instytutów, szpitali, sądów; komend, ambasad, konsulatów, szkół',
});
